let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gzS8W")).then(() => parcelRequire('5j1R8'));